import React, { useState } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import {
  CardContent,
  RadioGroup,
  Box,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";

function OntimeAndOverdueChart({ response }) {
  const [selectedType, setSelectedType] = useState("schedule");

  // Function to handle radio group change
  const handleRadioChange = (event) => {
    setSelectedType(event.target.value);
  };

  // Dynamically set pie chart data based on the selected radio value
  const pieData =
    selectedType === "schedule"
      ? [
          {
            id: 0,
            value: response.scheduledOntimeWOCompleted,
            label: `On Time(${response.scheduledOntimeWOCompleted})`,
            color: "#4CAF50",
          },
          {
            id: 1,
            value: response.scheduledOverdueWOCompleted,
            label: `Overdue(${response.scheduledOverdueWOCompleted})`,
            color: "#EF0107",
          },
        ]
      : [
          {
            id: 0,
            value: response.unscheduledOntimeWOCompleted,
            label: `On Time(${response.unscheduledOntimeWOCompleted})`,
            color: "#4CAF50",
          },
          {
            id: 1,
            value: response.unscheduledOverdueWOCompleted,
            label: `Overdue(${response.unscheduledOverdueWOCompleted})`,
            color: "#EF0107",
          },
        ];

  return (
    <StyledCard variant="outlined">
      <CardContent>
        <Typography
          mb={1.5}
          variant="h5"
          fontWeight={700}
          color={"text.primary"}
        >
          W.O On Time Vs Overdue
        </Typography>
        <Box>
          <RadioGroup
            row
            aria-labelledby="work-order-chart"
            name="work-order-chart"
            value={selectedType}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              value="schedule"
              control={<Radio size="small" />}
              label="Schedule"
            />
            <FormControlLabel
              value="unSchedule"
              control={<Radio size="small" />}
              label="Unschedule"
            />
          </RadioGroup>
        </Box>
        <Box width={"100%"}>
          <PieChart
            series={[{ data: pieData }]}
            height={300}
            slotProps={{
              legend: {
                direction: "row",
                position: { vertical: "bottom", horizontal: "middle" },
                padding: 0,
                itemMarkWidth: 15,
                itemMarkHeight: 15,
                markGap: 5,
                itemGap: 16,
                labelStyle: {
                  fontSize: 12,
                  color: "text.primary", 
                  fontWeight: 400,
                },
              },
            }}
            margin={{
              left: 60,
              bottom: 50,
              top: 50,
            }}
          />
        </Box>
      </CardContent>
    </StyledCard>
  );
}

export default OntimeAndOverdueChart;
